import { render, staticRenderFns } from "./ContinuousChangeBeneficialOwners.vue?vue&type=template&id=43826a0a&scoped=true&"
import script from "./ContinuousChangeBeneficialOwners.vue?vue&type=script&lang=js&"
export * from "./ContinuousChangeBeneficialOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43826a0a",
  null
  
)

export default component.exports